@if (geographicalSupplyChainMap()) {
  <app-supply-chain-map
    [supplyChain]="geographicalSupplyChainMap()"
    [isZoomPromptEnabled]="isZoomPromptEnabled"
  ></app-supply-chain-map>
}
